// extracted by mini-css-extract-plugin
export default {"modalOverlay":"rI-z","modalContent":"sI-z","header":"tI-z","close":"uI-z"};